import CenterBanner from './CenterBanner';
export default CenterBanner;